export default __webpack_public_path__ + "static/media/form_sample.7cc84b75.jpg";